import { usePage } from "@inertiajs/react";
import { useEffect } from "react";

const MARKER = "data-chat-integration";

export default function TawkChat() {
    const { props } = usePage();
    const snippet = props?.siteSettings?.tawkSrc;

    useEffect(() => {
        if (!snippet || typeof snippet !== "string" || !snippet.trim()) return;

        const load = () => {
            if (document.querySelector(`[${MARKER}]`)) return;

            const nodes = snippet.trim().startsWith("<")
                ? buildFromHtml(snippet)
                : [buildFromUrl(snippet)];

            nodes.forEach((node) => {
                if (node.nodeType === Node.ELEMENT_NODE) {
                    node.setAttribute(MARKER, "");
                }
                document.body.appendChild(node);
            });
        };

        const onReady = (event) => {
            const categories =
                event?.detail?.categories ||
                window.CookieConsent?.get?.()?.categories ||
                {};
            if (categories.preferences) load();
        };

        const initialCategories =
            window.CookieConsent?.get?.()?.categories || {};
        if (initialCategories.preferences) {
            load();
        } else {
            window.addEventListener("cookie-consent:ready", onReady);
            window.addEventListener("cookie-consent:consentChanged", onReady);
        }

        return () => {
            window.removeEventListener("cookie-consent:ready", onReady);
            window.removeEventListener(
                "cookie-consent:consentChanged",
                onReady,
            );
        };
    }, [snippet]);

    return null;
}

function buildFromUrl(src) {
    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    script.charset = "UTF-8";
    script.setAttribute("crossorigin", "*");
    return script;
}

function buildFromHtml(html) {
    const template = document.createElement("template");
    template.innerHTML = html;
    return Array.from(template.content.childNodes).map(recreateScripts);
}

function recreateScripts(node) {
    if (node.nodeName === "SCRIPT") {
        const script = document.createElement("script");
        Array.from(node.attributes).forEach(({ name, value }) =>
            script.setAttribute(name, value),
        );
        script.textContent = node.textContent;
        return script;
    }

    const clone = node.cloneNode(false);
    Array.from(node.childNodes).forEach((child) =>
        clone.appendChild(recreateScripts(child)),
    );
    return clone;
}
